// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"dbe01ee5","150":"81361306","472":"990bc45e","626":"96f6345c","786":"17f8ec79"}[chunkId] + ".chunk.js";
};